export const TITLES_LABELS = {
    LOGIN: {
        PATIENT_LOGIN: 'Signin',
        FORGOT_PASSWORD: 'Forgot Password',
        REGISTER: 'Signup',
        OTP: 'OTP verification'
    },
    ACCOUNT: {
        SAVE_BUTTON: 'Save Changes',
        CANCEL_BUTTON: 'Cancel'
    },
    LINKS: {
        FORGOT_PASSWORD: 'Forgot password?',
        REGISTER: "Sign up"
    },
    META: {
        LOGIN: 'Signin - xcarepro',
        REFER: 'Referrals - xcarepro',
        CLAIM: 'Claim Reward - xcarepro',
        APPOINTMENT: 'Appointments - xcarepro',
        ACCOUNT: 'Account - xcarepro',
        OTP: 'OTP - xcarepro'
    }
};